import React, {useContext} from "react";
import EcsContext from "../context/EcsContext"

const useEcs = () => {
    return useContext(EcsContext)
}

export default useEcs